import { styled } from '@material-ui/core';

export const IconImg = styled('img')({
  width: 40,
  display: 'block',
  padding: 8,
});
